import { call, put, takeLatest } from 'redux-saga/effects'

import backendAPI from '../axiosConfig'
import {
  loadContactMethods,
  storeContactMethods,
  addContactMethodRequest,
  addContactMethodSuccess,
  updateContactMethodRequest,
  updateContactMethodSuccess,
  deleteContactMethodRequest,
  deleteContactMethodSuccess,
  setContactMethodsError,
} from '../features/contactMethodsSlice'

const CONTACT_METHODS_ENDPOINT = '/api/casework/contactmethods/'

function* loadContactMethodsSaga() {
  try {
    const response = yield call(() => backendAPI.get(CONTACT_METHODS_ENDPOINT))
    yield put(storeContactMethods(response.data))
  } catch (error) {
    console.error(error)
    yield put(setContactMethodsError('Failed to load contact methods'))
  }
}

function* addContactMethodSaga(action) {
  const { values, contactMethod, callbackSuccess, callbackFailure } =
    action.payload
  try {
    const body = values || contactMethod
    const response = yield call(() =>
      backendAPI.post(CONTACT_METHODS_ENDPOINT, body)
    )
    yield put(addContactMethodSuccess(response.data))
    if (callbackSuccess) yield call(callbackSuccess, response.data)
  } catch (error) {
    console.error(error)
    yield put(setContactMethodsError('Failed to create contact method'))
    if (callbackFailure) yield call(callbackFailure, error?.response?.data)
  }
}

function* updateContactMethodSaga(action) {
  const { id, values, contactMethod, callbackSuccess, callbackFailure } =
    action.payload
  try {
    const body = values || contactMethod || {}
    const cmId = id ?? contactMethod?.id
    const response = yield call(() =>
      backendAPI.patch(CONTACT_METHODS_ENDPOINT + `${cmId}/`, body)
    )
    yield put(updateContactMethodSuccess(response.data))
    if (callbackSuccess) yield call(callbackSuccess, response.data)
  } catch (error) {
    console.error(error)
    yield put(setContactMethodsError('Failed to update contact method'))
    if (callbackFailure) yield call(callbackFailure, error?.response?.data)
  }
}

function* deleteContactMethodSaga(action) {
  const { id, callbackSuccess, callbackFailure } = action.payload
  try {
    yield call(() => backendAPI.delete(CONTACT_METHODS_ENDPOINT + `${id}/`))
    yield put(deleteContactMethodSuccess(id))
    if (callbackSuccess) yield call(callbackSuccess)
  } catch (error) {
    console.error(error)
    yield put(setContactMethodsError('Failed to delete contact method'))
    if (callbackFailure) yield call(callbackFailure)
  }
}

function* contactMethodsAPI() {
  yield takeLatest(loadContactMethods, loadContactMethodsSaga)
  yield takeLatest(addContactMethodRequest, addContactMethodSaga)
  yield takeLatest(updateContactMethodRequest, updateContactMethodSaga)
  yield takeLatest(deleteContactMethodRequest, deleteContactMethodSaga)
}

export default contactMethodsAPI
